import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { RHFTextField } from "../../../Shared/RHFTextField";
import { RHFRichEditor } from "../../../Shared/RHFRichEditor";
import { Info } from "@mui/icons-material";

const Basic = ({ hfControl, control }) => {
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
        <Info color="primary" />
        <Typography variant="h6" fontWeight={600}>
          Basic Information
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <RHFTextField
            required="Title is required"
            fullWidth
            name="title"
            label="Project Title"
            id="title"
            {...hfControl}
          />
        </Grid>
        <Grid item xs={12}>
          <RHFRichEditor
            required="Description is required"
            label="Describe this development project..."
            name="description"
            control={control}
            {...hfControl}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Basic;
